import React, {useState} from 'react'
import {useSelector} from "react-redux"
import {
  Stepper,
  Step,
  StepLabel,
  StepConnector
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Check from '@material-ui/icons/Check';
import StepOne from '../Components/StartCampaignForm/StepOne'
import StepTwo from '../Components/StartCampaignForm/StepTwo'
import StepThree from '../Components/StartCampaignForm/StepThree'
import StepFour from '../Components/StartCampaignForm/StepFour'
import FinalStep from '../Components/StartCampaignForm/FinalStep'
import Seo from '../Components/Helmet/Seo';



const QontoConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(2,182,99) 0%,rgb(2,182,99) 50%,rgba(2, 182, 98, 0.596) 100%)',
    },
  },
  completed: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(2,182,99) 0%,rgb(2,182,99) 50%,rgba(2, 182, 98, 0.596) 100%)',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(2,182,99) 0%, rgb(2,182,99) 50%, rgba(2, 182, 98, 0.596) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },
  completed: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(2,182,99) 0%, rgb(2,182,99) 50%, rgba(2, 182, 98, 0.596) 100%)',
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
  };

  return (
    <div
    className={clsx(classes.root, {
      [classes.active]: active,
      [classes.completed]: completed,

    })}
  >
    {completed ? <Check  /> : icons[String(props.icon)]}
  </div>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
};


const useStyles = makeStyles((theme) => (  {
  
    root: {
      width: '100%',
    },
    backButton: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    button: {
      marginRight: theme.spacing(1),
    },
    kamaminiColor:{
      // borderColor: '#008000',
      '& $line': {
        borderColor: '#008000',
      },
      // '&:hover': {
      //     backgroundColor: '#006400',
      //   },
    }
  }
  ));


function getSteps() {
    return ['Basics', 'Details', 'Récompense','Founding'];
  }


const StartCampaign = (props) => {

  const steps = getSteps();
  const [step,setStep] = useState(0)
  const userInfo = useSelector(state => state.auth.userInfo)

  

  !userInfo && props.history.push("/");
  

  const defaultValue = {
    title : '',
    tagline : '',
    location : '',
    category : '',
    duration : 0,
    // moneyRequest : 0,
  };
 

  const [projectData, setProjectData] = useState(defaultValue);
  const [moneyRequest, setMoneyRequest] = useState(0);


  // Step1() state
  const [imageUrl, setImageUrl] = useState([])
  const [featuredImageUrl, setFeaturedImageUrl] = useState([])
  const [featuredImgRequired, setFeaturedImgRequired] = useState(true);


// Step2() state
  const [youtubeUrl, setYoutubeUrl] = useState([])
  const [imageDropZoneUrl, setImageDropZoneUrl] = useState([])
  const [dropzoneImages, setdropzoneImages] = useState([]);

  const [saveInput, setSaveInput] = useState('')
  const [wysiwygData, setWysiwygData] = useState("<h3>Description brève</h3> <p>Les contributeurs financent des idées qui les passionnent et à des personnes en qui ils ont confiance. Voici quelques éléments à faire dans cette section :</p><ul><li>Présentez-vous et présentez votre parcours.</li><li>Décrivez brièvement votre projet et pourquoi elle est importante pour vous.</li><li>Expliquez l'ampleur de ce que les contributeurs vous aideront à réaliser</li></ul><p>N'oubliez pas de rester concis, mais personnel. Demandez-vous : si quelqu'un s'arrête de lire ce texte, serait-il prêt à faire une contribution ?</p><h3>Ce dont nous avons besoin et ce que vous obtenez</h3><p>Détaillez les choses pour les gens :</p><ul><li>Expliquez le montant du financement dont vous avez besoin et sa destination. Soyez transparent et précis : les gens doivent vous faire confiance pour vouloir vous financer.</li><li>Parlez-leur de vos avantages uniques. Suscitez leur enthousiasme !</li></ul><h3>L'impact</h3><p>N'hésitez pas à donner plus d'explications sur votre projet et à faire savoir aux gens la différence que leur contribution fera :</p><ul><li>Expliquez pourquoi votre projet est précieux pour le contributeur et pour le monde.</li><li>Mentionnez votre expérience réussie dans des projets de ce type (si vous en avez une).</li><li>Rendez les choses réelles pour les gens et créez la confiance.</li></ul><h3>Risques et défis</h3><p>Les gens apprécient votre transparence. Soyez ouvert et démarquez-vous en donnant un aperçu des risques et des obstacles que vous pourriez rencontrer sur la voie de la réalisation de votre objectif.</p><ul><li>Expliquez ce qui vous qualifie pour surmonter ces obstacles.</li><li>Décrivez votre plan pour résoudre ces défis.</li></ul><h3>Autres façons d'aider</h3><p>Certaines personnes ne peuvent tout simplement pas contribuer, mais cela ne veut pas dire qu'elles ne peuvent pas aider :</p><ul><li>Demandez-leur de faire passer le mot et de faire du bruit autour de votre campagne.</li><li>Rappelez-leur d'utiliser les outils de partage de Kamamini !</li></ul><h2>Et c'est tout ce qu'il y a à faire !!!!</h2>")
  
  const [faq,setFaq] = useState([{question: '',response: '', id:0 }])
  const [pitchContentRequired, setpitchContentRequired] = useState(true)
  
  // useEffect(() => {
  //   if(!youtubeUrl.length && !imageDropZoneUrl.length ){
  //     setpitchContentRequired(true)
  //   }
  //   if(youtubeUrl.length || imageDropZoneUrl.length){
  //     setpitchContentRequired(false)
  //   }

  //  }, [youtubeUrl,imageDropZoneUrl])

  // Step3() state
  const [perk,setPerk] = useState([])
  
  const checkFaqErrors = (faq) => {
    for (let i = 0; i < faq.length; i++) {
      if((faq[i].question !== "" && faq[i].response === "") || (faq[i].question === "" && faq[i].response !== "") ){
        return true;
      }
    }
    return false;
  }

  const deleteEmptyFaq = (faq) => {
    for (let i = 0; i < faq.length; i++) {
      if (faq[i].question === "" && faq[i].response === "") {
        setFaq((curr) => curr.filter((currFaq) => currFaq !== faq[i]))
      }
    }
  }

  const handleChange = (e) => {   
    setProjectData({ ...projectData, [e.target.id]: e.target.value });
  };

 const CustumStepper = () => {
  return (
  <Stepper  activeStep={step} alternativeLabel connector={<QontoConnector />}>
    {steps.map((label) => (
      <Step  key={label}>
        <StepLabel StepIconComponent={QontoStepIcon} >{label}</StepLabel>
      </Step>
    ))}
  </Stepper>
  )
}



  const nextStep = () => {
    setStep((prev) => prev + 1);
  };

  const prevStep = () => {
    setStep((prev) => prev - 1);
  };



  const handleSaveInput = (e) => {
    setSaveInput(e.target.value)
  }

  const addYoutubeUrl =() =>{
   
  if(saveInput !== '' && saveInput.includes("youtube.com") && youtubeUrl.indexOf(saveInput) === -1){
    setYoutubeUrl(prev => [...prev, saveInput])
    setSaveInput('')
    setpitchContentRequired(false)
  }

}

const deleteVideoUrl = (url) =>{
  if(youtubeUrl.length > 1){
    setYoutubeUrl(prev => prev.filter((currUrl) => currUrl !== url ))
  }
  if(youtubeUrl.length === 1){
    setYoutubeUrl(prev => prev.filter((currUrl) => currUrl !== url ))
    // setpitchContentRequired(true)
  }

}


// Send image to Firebase
// const [imageUrl, setImageUrl] = useState(null)
// const handleChangeImage = async(e)=>{
//   const file = e.target.files[0];
//   if(file && file['type'].split('/')[0] === 'image'){
//     setImageName(file.name)
//       const storageRef= storage.ref()
//       const fileRef= storageRef.child('projects/'+file.name)
//       console.log(fileRef);
//       await fileRef.put(file)

//        setImageUrl( await fileRef.getDownloadURL())
//   }

// }
//  <input type="file" required className="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01" onChange={(e)=>handleChangeImage(e)} lang="fr" />
// <label className="custom-file-label " htmlFor="inputGroupFile01" data-browse="Parcourir">{imageName}</label> 






  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return <StepOne 
        nextStep={nextStep} 
        step={step}
        imageUrl={imageUrl}
        CustumStepper={CustumStepper}
        projectData={projectData}
        handleChange={handleChange}
        featuredImgRequired={featuredImgRequired}
        setFeaturedImgRequired={setFeaturedImgRequired}
        setImageUrl={setImageUrl}
        featuredImageUrl={featuredImageUrl}
        setFeaturedImageUrl={setFeaturedImageUrl}

        />;
        
      case 1:
        return <StepTwo
                  nextStep={nextStep} 
                  prevStep={prevStep} 
                  handleSaveInput={handleSaveInput}
                  addYoutubeUrl={addYoutubeUrl}
                  saveInput={saveInput}
                  youtubeUrl={youtubeUrl}
                  deleteVideoUrl={deleteVideoUrl}
                  wysiwygData={wysiwygData}
                  setWysiwygData={setWysiwygData}
                  faq={faq}
                  setFaq={setFaq}
                  checkFaqErrors= {checkFaqErrors}
                  deleteEmptyFaq={deleteEmptyFaq}
                  getSteps={getSteps}
                  CustumStepper={CustumStepper}
                  dropzoneImages={dropzoneImages}
                  setdropzoneImages={setdropzoneImages}
                  imageDropZoneUrl={imageDropZoneUrl}
                  setImageDropZoneUrl={setImageDropZoneUrl}
                  pitchContentRequired={pitchContentRequired}
                  setpitchContentRequired={setpitchContentRequired}
                 
                  
                  />;
      case 2:
        return <StepThree
                  nextStep={nextStep} 
                  prevStep={prevStep} 
                  getSteps={getSteps}
                  step={step} 
                  perk={perk}
                  setPerk={setPerk}
                  CustumStepper={CustumStepper}

              />
      case 3:
        return <StepFour
                  nextStep={nextStep}
                  prevStep={prevStep} 
                  CustumStepper={CustumStepper}
                  moneyRequest={moneyRequest}
                  setMoneyRequest={setMoneyRequest}

              />
      case 4:
        return <FinalStep
                  prevStep={prevStep} 
                  projectData={projectData}
                  imageUrl={featuredImageUrl}
                  youtubeUrl={youtubeUrl}
                  imageDropZoneUrl={imageDropZoneUrl}
                  wysiwygData={wysiwygData}
                  faq={faq}
                  perk={perk}
                  moneyRequest={moneyRequest}

              />
      
      default:
        return 'Unknown stepIndex';
    }
  }

    
    return (
        <>
        <Seo
          title="Lancer une Campagne"
          description="Partagez votre idée de projet sur Kamamini et lancez votre campagne de financement participatif. Rendez votre rêve réalité avec Kamamini."
          name="Kamamini"
          type="website"
        />
        {getStepContent(step)}
            
        </>
    )
}

export default StartCampaign
